
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import ConstructionServices from '../pages/services/construction/page';
import OilGasServices from '../pages/services/oil/page';
import GoldServices from '../pages/services/gold/page';
import DefenseServices from '../pages/services/defense/page';
import ConsultationPage from '../pages/consultation/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/services/construction',
    element: <ConstructionServices />,
  },
  {
    path: '/services/oil',
    element: <OilGasServices />,
  },
  {
    path: '/services/gold',
    element: <GoldServices />,
  },
  {
    path: '/services/defense',
    element: <DefenseServices />,
  },
  {
    path: '/consultation',
    element: <ConsultationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
